import { render, staticRenderFns } from "./ModalStart.vue?vue&type=template&id=2df64a71&scoped=true&"
import script from "./ModalStart.vue?vue&type=script&lang=js&"
export * from "./ModalStart.vue?vue&type=script&lang=js&"
import style0 from "./ModalStart.vue?vue&type=style&index=0&id=2df64a71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df64a71",
  null
  
)

export default component.exports